export const USER_SIGNATURE_URL = 'core/user/';

export const FRONT_HASH_URL = 'front-hash';
